module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-breadcrumb', {
    staticClass: "bread",
    attrs: {
      "separator": "/"
    }
  }, [_c('el-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'materialManager'
      }
    }
  }, [_vm._v("素材管理")]), _vm._v(" "), _c('el-breadcrumb-item', [_vm._v("新增")])], 1), _vm._v(" "), _c('el-form', {
    ref: "materiaForm",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.materiaForm,
      "rules": _vm.materiarules,
      "label-width": "100px",
      "label-position": _vm.labelposition
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "素材名称",
      "prop": "resources_name"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "30%"
    },
    attrs: {
      "maxlength": 20
    },
    model: {
      value: (_vm.materiaForm.resources_name),
      callback: function($$v) {
        _vm.$set(_vm.materiaForm, "resources_name", $$v)
      },
      expression: "materiaForm.resources_name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "素材类型",
      "prop": "resources_type_id"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择素材类型"
    },
    on: {
      "change": function($event) {
        _vm.onChangeResourcesType()
      }
    },
    model: {
      value: (_vm.materiaForm.resources_type_id),
      callback: function($$v) {
        _vm.$set(_vm.materiaForm, "resources_type_id", $$v)
      },
      expression: "materiaForm.resources_type_id"
    }
  }, _vm._l((_vm.materiaTypeList), function(item) {
    return _c('el-option', {
      attrs: {
        "label": item.resources_type_name,
        "value": item.resources_type_id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    class: {
      isUploadDsplay: _vm.isShowChangeUpload
    },
    attrs: {
      "label": "上传方式",
      "prop": "resource_upload_type"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择上传方式"
    },
    on: {
      "change": _vm.onChangeFileUploadType
    },
    model: {
      value: (_vm.materiaForm.resource_upload_type),
      callback: function($$v) {
        _vm.$set(_vm.materiaForm, "resource_upload_type", $$v)
      },
      expression: "materiaForm.resource_upload_type"
    }
  }, _vm._l((_vm.materiaTypeList2), function(item) {
    return _c('el-option', {
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "图片"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.materiaForm.download_url,
      "width": "200px",
      "id": "img"
    }
  })]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "fileList"
    }
  }, [_c('el-upload', {
    ref: "upload",
    staticClass: "upload-demo",
    class: {
      isUploadDsplay: _vm.isUpload
    },
    staticStyle: {
      "width": "35%"
    },
    attrs: {
      "with-credentials": "",
      "action": _vm.uploadurl,
      "data": _vm.upload_data,
      "on-preview": _vm.handlePreview,
      "on-remove": _vm.handleRemove,
      "on-success": _vm.handleSuccess,
      "before-upload": _vm.handlebefupload
    }
  }, [_c('span', [(_vm.materiaForm.download_url == '') ? _c('el-button', {
    attrs: {
      "size": "small",
      "type": "success"
    }
  }, [_vm._v("上传素材")]) : _vm._e(), _vm._v(" "), (_vm.materiaForm.download_url != '') ? _c('el-button', {
    attrs: {
      "size": "small",
      "type": "success"
    }
  }, [_vm._v("更新素材")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v("大小不超过1GB")])], 1)])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.submitForm('materiaForm')
      }
    }
  }, [_vm._v("确 定")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.close()
      }
    }
  }, [_vm._v("取消")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-10a23c46!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/material/MaterialAdd.vue
// module id = 1034
// module chunks = 2